import { Box, Container, Grid, styled, Typography } from '@mui/material'
import RefreshTwoToneIcon from '@mui/icons-material/RefreshTwoTone';
import { LoadingButton } from '@mui/lab'
import { Player } from '@lottiefiles/react-lottie-player'

const MainContent = styled(Box)(
    () => `
    height: 100%;
    display: flex;
    flex: 1;
    overflow: auto;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`
);

function Status500() {
return <MainContent><Grid
    container
    sx={{ height: '100%' }}
    alignItems="stretch"
    spacing={0}
>
    <Grid
        xs={12}
        alignItems="center"
        display="flex"
        justifyContent="center"
        item
    >
        <Container maxWidth="sm">
            <Box textAlign="center">
                <Player
                    autoplay
                    loop
                    src="/assets/images/error.json"
                    style={{
                        width: '70%'
                    }}
                />
                <Typography variant="h6" sx={{ my: 2 }}>
                    خطایی رخ داده است.
                </Typography>
                <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    fontWeight="normal"
                    sx={{ mb: 4 }}
                >
                    یک خطا در درخواست شما رخ داده است. لطفا دوباره امتحان کنید، یا با پشتیبانی تماس بگیرید
                </Typography>
                <LoadingButton
                    onClick={() => {
                        window.location.reload()
                    }}
                    variant="outlined"
                    color="primary"
                    startIcon={<RefreshTwoToneIcon />}
                >
                    تلاش دوباره
                </LoadingButton>
            </Box>
        </Container>
    </Grid>
</Grid>
</MainContent>
}

export default Status500
